import {
  AdminPanelSettings,
  Delete,
  Edit,
  Visibility,
} from "@mui/icons-material";
import { Box, useTheme } from "@mui/material";
import React, { FC } from "react";
import Button from "./Button";

interface Props {
  id: number;
  handleEdit?: (id: number) => void;
  handleView?: (id: number) => void;
  handleDelete?: (id: number) => void;
  handleAdminRoute?: (id: number) => void;
}

const TableActions: FC<Props> = (props) => {
  const { id, handleEdit, handleView, handleDelete, handleAdminRoute } = props;
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        color: theme.palette.primary.main,
      }}
      component={"span"}
    >
      {!!handleEdit && (
        <Button
          onClick={() => handleEdit(id)}
          color="primary"
          icon={<Edit fontSize={"small"} aria-label="edit-button" />}
        />
      )}

      {!!handleView && (
        <Button
          onClick={() => handleView(id)}
          color="success"
          icon={<Visibility fontSize={"small"} aria-label="view-button" />}
        />
      )}
      {!!handleDelete && (
        <Button
          onClick={() => handleDelete(id)}
          color="error"
          icon={<Delete fontSize={"small"} aria-label="delete-button" />}
        />
      )}
      {!!handleAdminRoute && (
        <Button
          onClick={() => handleAdminRoute(id)}
          color="secondary"
          icon={
            <AdminPanelSettings fontSize={"small"} aria-label="admin-button" />
          }
        />
      )}
    </Box>
  );
};

export default TableActions;
